import { TApplicationState } from 'shared/types/redux';

export function selectAlert(state: TApplicationState) {
  return state.alert;
}
